import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LibraryDbIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12 0.25C7.25001 0.25 2.45001 1.64 2.45001 4.3V19.7C2.45001 22.36 7.25001 23.75 12 23.75C16.75 23.75 21.55 22.36 21.55 19.7V4.3C21.55 1.64 16.75 0.25 12 0.25ZM3.95001 6.57C5.74001 7.74 8.88001 8.35 12 8.35C15.12 8.35 18.26 7.74 20.05 6.57V9.83C19.43 10.89 16.49 12.11 12 12.11C7.51001 12.11 4.57001 10.89 3.95001 9.83V6.57ZM3.95001 11.54C5.72001 12.73 8.92001 13.36 12 13.36C15.08 13.36 18.28 12.73 20.05 11.54V14.96C19.43 16.02 16.49 17.24 12 17.24C7.51001 17.24 4.57001 16.02 3.95001 14.96V11.54ZM12 1.75C16.91 1.75 20.05 3.26 20.05 4.3C20.05 5.34 16.91 6.85 12 6.85C7.09001 6.85 3.95001 5.34 3.95001 4.3C3.95001 3.26 7.09001 1.75 12 1.75ZM12 22.25C7.09001 22.25 3.95001 20.74 3.95001 19.7V16.67C5.72001 17.86 8.92001 18.49 12 18.49C15.08 18.49 18.28 17.86 20.05 16.67V19.7C20.05 20.74 16.91 22.25 12 22.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LibraryDbIcon.displayName = 'LibraryDbIcon';
